"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: payroll/payroll-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpayroll%2Fpayroll-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollServiceClient = exports.GetIncomeSummaryResponse = exports.GetIncomeSummaryRequest = exports.GetIncomeActivityResponse = exports.GetIncomeActivityRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const paging_1 = require("../paging/paging");
const activity_view_1 = require("../txactivity/activity-view");
const income_summary_1 = require("./income-summary");
const protobufPackage = 'com.step.payroll.proto';
function createBaseGetIncomeActivityRequest() {
    return { paging: undefined };
}
exports.GetIncomeActivityRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingRequest.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingRequest.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetIncomeActivityRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIncomeActivityRequest();
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingRequest.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetIncomeActivityResponse() {
    return { activities: [], paging: undefined };
}
exports.GetIncomeActivityResponse = {
    fromJSON(object) {
        const message = {
            activities: globalThis.Array.isArray(object?.activities)
                ? object.activities.map((e) => activity_view_1.ActivityView.fromJSON(e))
                : [],
        };
        if (isSet(object.paging)) {
            message.paging = paging_1.PagingResponse.fromJSON(object.paging);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.activities?.length) {
            obj.activities = message.activities.map((e) => activity_view_1.ActivityView.toJSON(e));
        }
        if (message.paging !== undefined) {
            obj.paging = paging_1.PagingResponse.toJSON(message.paging);
        }
        return obj;
    },
    create(base) {
        return exports.GetIncomeActivityResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIncomeActivityResponse();
        message.activities = object.activities?.map((e) => activity_view_1.ActivityView.fromPartial(e)) || [];
        message.paging = (object.paging !== undefined && object.paging !== null)
            ? paging_1.PagingResponse.fromPartial(object.paging)
            : undefined;
        return message;
    },
};
function createBaseGetIncomeSummaryRequest() {
    return {};
}
exports.GetIncomeSummaryRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetIncomeSummaryRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetIncomeSummaryRequest();
        return message;
    },
};
function createBaseGetIncomeSummaryResponse() {
    return { summary: income_summary_1.IncomeSummary.fromPartial({}) };
}
exports.GetIncomeSummaryResponse = {
    fromJSON(object) {
        const message = {
            summary: isSet(object.summary)
                ? income_summary_1.IncomeSummary.fromJSON(object.summary)
                : income_summary_1.IncomeSummary.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== undefined) {
            obj.summary = income_summary_1.IncomeSummary.toJSON(message.summary);
        }
        return obj;
    },
    create(base) {
        return exports.GetIncomeSummaryResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetIncomeSummaryResponse();
        message.summary = (object.summary !== undefined && object.summary !== null)
            ? income_summary_1.IncomeSummary.fromPartial(object.summary)
            : income_summary_1.IncomeSummary.fromPartial({});
        return message;
    },
};
/**
 * Payroll Service.
 */
class PayrollServiceClient {
    rpc;
    name = 'com.step.payroll.proto.PayrollService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/payroll';
    methods = [{
            name: 'GetIncomeActivity',
            requestType: exports.GetIncomeActivityRequest,
            responseType: exports.GetIncomeActivityResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetIncomeSummary',
            requestType: exports.GetIncomeSummaryRequest,
            responseType: exports.GetIncomeSummaryResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get recent income transaction activity
     */
    getIncomeActivity(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get income summary
     */
    getIncomeSummary(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.PayrollServiceClient = PayrollServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=payroll-service.js.map